import Swiper, {
  Navigation, Lazy,
} from 'swiper';
import BaseComponent from 'scripts/BaseComponent.js';

export default class ArticleSuggestedProducts extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      swiperContainer: '.js-productCarousel',
      prevArrow: '.js-productCarouselPrev',
      nextArrow: '.js-productCarouselNext',
    };

    this.dom = {
      $component: component,
      $swiperContainer: this.$get(this.refs.swiperContainer),
      $prevArrow: this.$getAll(this.refs.prevArrow),
      $nextArrow: this.$getAll(this.refs.nextArrow),
    };

    this.state = {
      swiper: null,
    };

    this.mount();
    this.init();
  }

  mount() {
    super.mount();
  }

  init() {
    this.initSlider();
  }

  initSlider() {
    const { dom, state } = this;

    if (dom.$swiperContainer) {
      state.swiper = new Swiper(dom.$swiperContainer, {
        modules: [Navigation, Lazy],
        init: false,
        preloadImages: false,
        slidesPerView: 2,
        loop: true,
        navigation: {
          nextEl: dom.$nextArrow,
          prevEl: dom.$prevArrow,
        },
        lazy: {
          loadOnTransitionStart: true,
        },
        breakpoints: {
          320: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 3,
          },
        },
      });

      state.swiper.init();
    }
  }
}
